export const AGE_GROUP_OPTIONS = [
  {
    value: 'under_5',
    label: 'Under 5 years',
  },
  {
    value: '5_7',
    label: '5–7 years',
  },
  {
    value: '8_10',
    label: '8–10 years',
  },
  {
    value: '11_13',
    label: '11–13 years',
  },
  {
    value: '14_17',
    label: '14–17 years',
  },
  {
    value: '18_plus',
    label: '18+ years',
  },
];

export const getAgeGroupLabel = (value) => {
  return (
    AGE_GROUP_OPTIONS.find(
      (option) => option.value === value
    )?.label || 'Not set'
  );
};
